import React, { useEffect, useState } from "react";
import styles from "../../../assets/stylesheets/sass/AdminPanel.module.scss";
import { ReactSession }  from 'react-client-session';
import Dropdownlist from '../../customComponents/Dropdownlist';
import Navigation from "../../navigation/Navigation";
import CustomerDashboardComp from "./DashboardComp";
import Files from "./Files";
import File from "./[file]";
import Settings from "./Settings";
import Documents from "./Documents";
import UserManagement from "./UserManagement";
import localForage from "localforage";
import { Routes, Route, useNavigate } from 'react-router-dom';
import { getFiles } from "../../../functions/files";
import { getFitDocToken } from "../../../functions/token";
import LoadingPage from "../Loading";
import { useDispatch, useSelector } from "react-redux";
import {setAllDoctypes, setAllFiletypes, setAllGroups, setAllRelations, setAllRoles, setAllRolesLabels, setContent, setDoctypeTranslations, setFiletypeTranslations, setNFUDocs, setRelation, setUserData, setUserRights} from "../../../redux/actions/index";
import Invoices from "./Invoices";
import { handleGetNFUDocs } from "../../../functions/dashboard";
import { handleGetAllGroups, handleGetRelation, handleGetUserRights } from "../../../functions/fetch";
import { getContent } from "../../../functions/conversions";
import { subMonths, subWeeks, setDefaultOptions } from "date-fns";
import { getFilesNew } from "../../../functions/filesv2";
import WeighingTicket from "./WeighingTicket";
import InfoFiches from "./InfoFiches";
import DocumentViewer from "../../helpers/document-viewer";
import axios from "axios";
import { fr, nl, enUS } from "date-fns/locale";

let retryFetch = 3;
export default function CustomerDashboard({language}){
    const navigate = useNavigate()
    const userdata = useSelector((state)=>state.userdata);

    const [lang_updater, setlang_updater] = useState("");
    const [content_state, setcontent_state] = useState({});
    const dispatch = useDispatch();

    useEffect(()=>{
		setlang_updater(language);
		ReactSession.set("language", language);

        switch (language) {
            case "N":
                setDefaultOptions({locale: nl})
                break;
            case "F":
                setDefaultOptions({locale: fr})
                break;
            case "E":
                setDefaultOptions({locale: enUS})
                break;
        }
	}, [language])

    const handleChangeLanguage = (lang) =>{
		setlang_updater(lang);
		ReactSession.set("language", lang);
	}

    const [view_usermanagement, setview_usermanagement] = useState(false);
    const [view_infofiche, setview_infofiche] = useState(false)
    const [view_invoices, setview_invoices] = useState(true);
    const [view_weighingticket, setview_weighingticket] = useState(true);

    let navigationData = {
        "admin": {
            [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_dashboard && content_state[ReactSession.get("language")].General.navigation_dashboard) : "Dashboard"]: {
                [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_dashboard && content_state[ReactSession.get("language")].General.navigation_dashboard) : "Dashboard"]: true
            },
            [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_files && content_state[ReactSession.get("language")].General.navigation_files) : "Files"]: {
                [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_files && content_state[ReactSession.get("language")].General.navigation_files) : "Files"]: true,
            },
            [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_documents && content_state[ReactSession.get("language")].General.navigation_documents) : "Documents"]: {
                [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_documents && content_state[ReactSession.get("language")].General.navigation_documents) : "Documents"]: true,
            },
            [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_invoices && content_state[ReactSession.get("language")].General.navigation_invoices) : "Invoices"]: {
                [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_invoices && content_state[ReactSession.get("language")].General.navigation_invoices) : "Invoices"]: view_invoices
            },
            [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_weighingticket && content_state[ReactSession.get("language")].General.navigation_weighingticket) : "Weighing ticket"]: {
                [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_weighingticket && content_state[ReactSession.get("language")].General.navigation_weighingticket) : "Weighing ticket"]: view_weighingticket
            },
            "Info fiche": {
                "Info fiche": view_infofiche
            },
            [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_usermanagement && content_state[ReactSession.get("language")].General.navigation_usermanagement) : "User management"]: {
                [content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_usermanagement && content_state[ReactSession.get("language")].General.navigation_usermanagement) : "User management"]: view_usermanagement,
            }
        }
    }

    window.onunload = function () {
        if(window.localStorage.getItem("rememberMe") !== "true"){
            localStorage.removeItem('username');
            localStorage.removeItem('password');    
        }
        window.localStorage.setItem("active_navigation_item", 'Dashboard');
        window.sessionStorage.setItem("page_files", 1)
    }

    const [showDashboard, setshowDashboard] = useState(false);
    const [selectedPage, setselectedPage] = useState("Dashboard");


    const handleGetDossiers = async (userdata) =>{
        if(!userdata){ console.log("no userdata"); return;}


        let types = [];
        let lfTableItems = await localForage.getItem("tableItems");

        if(lfTableItems){
            types = lfTableItems
        }
        else{
            const resAdminSettings = await fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsGet?token="+window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            let resultAdminSettings = await resAdminSettings.json();
            if(resultAdminSettings.object){
                if(resultAdminSettings.object.json){
                    if(resultAdminSettings.object.json.table_items){
                        types = resultAdminSettings.object.json.table_items;
                        localForage.setItem("tableItems", resultAdminSettings.object.json.table_items)
                    }        
                }
            }
        }

        let endDate = new Date();
        let ed = endDate.getDate().toString();
        if(ed.length < 2){ed = "0"+ed}
        let em = (endDate.getMonth() + 1).toString();
        if(em.length < 2){em = "0"+em}
        let ey = endDate.getFullYear().toString();
        endDate = ey + em + ed

        let startDate = subWeeks(new Date(), 1);
        if(JSON.parse(window.sessionStorage.getItem("user_data")).role.toString() !== "1"){
            startDate = subMonths(new Date(), 6)
        }
        let sd = startDate.getDate().toString();
        if(sd.length < 2){sd = "0"+sd}
        let sm = (startDate.getMonth() + 1).toString();
        if(sm.length < 2){sm = "0"+sm}
        let sy = startDate.getFullYear().toString();
        startDate = sy + sm + sd

        let f = await getFilesNew(JSON.parse(window.sessionStorage.getItem("user_data")), startDate, endDate);
        if(Array.isArray(f)){
            localForage.setItem("dossiers", f);
            //setshowLoader(false);
        }

        return f
    }

    const [showLoader, setshowLoader] = useState(true);

    async function handleLoadContent () {
        const { data:content } = await axios.get(`${process.env.REACT_APP_SERVER_LINK}content`)
        if(!content) return;
        setcontent_state(content)
        dispatch(setContent(content))
    }

    useEffect(()=>{
        handleLoadContent()

        getDataFetch()

        let user_data = JSON.parse(window.sessionStorage.getItem("user_data"));
        if(user_data.user.right.adduser === true && user_data.user.right.deleteuser === true && user_data.user.right.changeuser === true){
            setview_usermanagement(true);
        }
        if(user_data) {
            dispatch(setUserData(user_data))
        }
        return () => {}
    }, [])


    const fetchDoctypes = async () => {
        try {
            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"documentTypes?token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))))
            const d = await f.json();
            let doctypes = d.object;
            dispatch(setAllDoctypes(doctypes))
            localForage.setItem("docTypes", doctypes)

            let obj_translations = {}
            if(!doctypes){return;}
            for (let i = 0; i < doctypes.length; i++) {
                obj_translations[doctypes[i].doctype] = {}
                obj_translations[doctypes[i].doctype].N = doctypes[i].docoms.find(v => v.nationid === 12) ? doctypes[i].docoms.find(v => v.nationid === 12).oms : doctypes[i].doctype
                obj_translations[doctypes[i].doctype].F = doctypes[i].docoms.find(v => v.nationid === 5) ? doctypes[i].docoms.find(v => v.nationid === 5).oms : doctypes[i].doctype
                obj_translations[doctypes[i].doctype].E = doctypes[i].docoms.find(v => v.nationid === 3) ? doctypes[i].docoms.find(v => v.nationid === 3).oms : doctypes[i].doctype
            }
            dispatch(setDoctypeTranslations(obj_translations));
        } catch (error) {
            console.log(error)
        }
    }

    const fetchFiletypes = async () => {
        try {
            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"filetypeGetAll?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token)
            const d = await f.json();
            if(d.errorcode === 0){
                window.sessionStorage.setItem("filetypeGetAll", JSON.stringify(d.object));
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchReadFiles = async () => {
        try {
            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"filesReadGetAll?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token)
            const d = await f.json();
            if(d.errorcode === 0){
                localForage.setItem("filesReadAll", d.object);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchUserSettings = async () => {
        try {
            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"userSettingsGet?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token+"&user="+JSON.parse(window.sessionStorage.getItem("user_data")).id)
            const d = await f.json();
            if(d.errorcode === 0){
                localForage.setItem("userSettings", d.object);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchDossierTypes = async () => {
        try {
            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"dossierTypes?token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))))
            const d = await f.json();
            if(d.errorcode === 0){
                //Removing duplicates by name (because the returned array wasn't that clean)
                d.object = d.object.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.name === value.name
                    ))
                )
                
                dispatch(setAllFiletypes(d.object))
                localForage.setItem("dossierTypes", d.object)

                let obj = {}
                for (let i = 0; i < d.object.length; i++) {
                    switch (d.object[i].name.toString().toLowerCase()) {
                        case "paardenmest":
                            obj[d.object[i].name] = {}
                            obj[d.object[i].name].N = getContent("General", "file_translation_horsemanure", "N", content_state, "Paardenmest")
                            obj[d.object[i].name].E = getContent("General", "file_translation_horsemanure", "E", content_state, "Horse manure")
                            obj[d.object[i].name].F = getContent("General", "file_translation_horsemanure", "F", content_state, "Fumier de cheval")
                            break;
                        case "kippenmest":
                            obj[d.object[i].name] = {}
                            obj[d.object[i].name].N = getContent("General", "file_translation_chickenmanure", "N", content_state, "Kippenmest")
                            obj[d.object[i].name].E = getContent("General", "file_translation_chickenmanure", "E", content_state, "Chicken manure")
                            obj[d.object[i].name].F = getContent("General", "file_translation_chickenmanure", "F", content_state, "Fumier de poulet")
                            break;
                        case "schuimaarde":
                            obj[d.object[i].name] = {}
                            obj[d.object[i].name].N = getContent("General", "file_translation_foamearth", "N", content_state, "Schuimaarde")
                            obj[d.object[i].name].E = getContent("General", "file_translation_foamearth", "E", content_state, "Foam earth")
                            obj[d.object[i].name].F = getContent("General", "file_translation_foamearth", "F", content_state, "Terre de mousse")
                            break;
                        case "stro":
                            obj[d.object[i].name] = {}
                            obj[d.object[i].name].N = getContent("General", "file_translation_straw", "N", content_state, "Stro")
                            obj[d.object[i].name].E = getContent("General", "file_translation_straw", "E", content_state, "Straw")
                            obj[d.object[i].name].F = getContent("General", "file_translation_straw", "F", content_state, "Paille")
                            break;
                        case "gips":
                            obj[d.object[i].name] = {}
                            obj[d.object[i].name].N = getContent("General", "file_translation_cast", "N", content_state, "Gips")
                            obj[d.object[i].name].E = getContent("General", "file_translation_cast", "E", content_state, "Cast")
                            obj[d.object[i].name].F = getContent("General", "file_translation_cast", "F", content_state, "Moulage")
                            break;
                        case "substraat":
                            obj[d.object[i].name] = {}
                            obj[d.object[i].name].N = getContent("General", "file_translation_substrate", "N", content_state, "Substraat")
                            obj[d.object[i].name].E = getContent("General", "file_translation_substrate", "E", content_state, "Substrate")
                            obj[d.object[i].name].F = getContent("General", "file_translation_substrate", "F", content_state, "Substrat")
                            break;
                        case "dekaarde":
                            obj[d.object[i].name] = {}
                            obj[d.object[i].name].N = getContent("General", "file_translation_casingsoil", "N", content_state, "Dekaarde")
                            obj[d.object[i].name].E = getContent("General", "file_translation_casingsoil", "E", content_state, "Casing soil")
                            obj[d.object[i].name].F = getContent("General", "file_translation_casingsoil", "F", content_state, "Terre de gobetage")
                            break;
                        default:
                            break;
                    }
                }
                dispatch(setFiletypeTranslations(obj))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchRelation = async () => {
        let relation = await handleGetRelation(JSON.parse(window.sessionStorage.getItem("user_data")));
        if(relation.errorcode === 0 && relation.object){
            dispatch(setRelation(relation.object.relations[0]))
        }
    }

    const fetchNFUDocs = async () => {
        let nfuDocs = await handleGetNFUDocs(JSON.parse(window.sessionStorage.getItem("user_data")))
        if(nfuDocs.errorcode === 0){dispatch(setNFUDocs(nfuDocs.object))}
    }

    const fetchBDocs = async () => {
        try {
            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"getBegeleidendDoc?token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))))
            const d = await f.json();
            if(d.errorcode === 0){
                window.localStorage.setItem("bdoc", JSON.stringify(d.object))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchRelations = async () => {

        try {
            const user_data = JSON.parse(window.sessionStorage.getItem("user_data"));
            let relations = []

            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"carriers?token="+user_data.token)
            const d = await f.json();
            if(d.errorcode === 0){
                let tmp_carriers = []
                for (let i = 0; i < d.object.length; i++) {
                    tmp_carriers = tmp_carriers.concat(d.object[i].car_code + "_" + d.object[i].car_name)
                }
                localForage.setItem("carriers", tmp_carriers);
                relations = relations.concat(tmp_carriers);
            }

            let customers = []
            let c_f = await fetch(process.env.REACT_APP_SERVER_LINK+"customers?token="+user_data.token)
            const c_d = await c_f.json();
            if(c_d.errorcode === 0){
                let tmp_customers = []
                for (let i = 0; i < c_d.object.length; i++) {
                    tmp_customers = tmp_customers.concat(c_d.object[i].cus_code + "_" + c_d.object[i].cus_name)
                }
                customers = tmp_customers;
                localForage.setItem("customers", tmp_customers);
                relations = relations.concat(tmp_customers);
            }

            let s_f = await fetch(process.env.REACT_APP_SERVER_LINK+"suppliers?token="+user_data.token)
            const s_d = await s_f.json();
            if(s_d.errorcode === 0){
                let tmp_suppliers = []
                for (let i = 0; i < s_d.object.length; i++) {
                    tmp_suppliers = tmp_suppliers.concat(s_d.object[i].sup_code + "_" + s_d.object[i].sup_name)
                }
                tmp_suppliers = tmp_suppliers.concat(customers);
                localForage.setItem("suppliers", tmp_suppliers);
                relations = relations.concat(tmp_suppliers);
            }

            dispatch(setAllRelations(relations))
        } catch (error) {
            console.log(error)
        }
    }

    const fetchRoles = async () => {
        try {
            let f = await fetch(process.env.REACT_APP_SERVER_LINK+"rolesGetAll?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token)
            const d = await f.json();
            if(d.errorcode === 0){
                dispatch(setAllRoles(d.object))
                localForage.setItem("roles", d.object);

                let roles = d.object;
                let roles_labels = []
                roles.forEach(role => {
                    roles_labels = roles_labels.concat(role.role)
                });

                dispatch(setAllRolesLabels(roles_labels))
                localForage.setItem("rolesLabels", roles_labels)
            }
        } catch (error) {
            console.log(error)
        } 
    }

    const fetchAdminSettings = async () => {
        try {
            const resAdminSettings = await fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsGet?token="+window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            let resultAdminSettings = await resAdminSettings.json();
            if(resultAdminSettings.object){
                if(resultAdminSettings.object.json){
                    if(resultAdminSettings.object.json.table_items){
                        localForage.setItem("tableItems", resultAdminSettings.object.json.table_items)
                    }
                    if(resultAdminSettings.object.json.list_items){
                        localForage.setItem("listItems", resultAdminSettings.object.json.list_items)
                    }
                    localForage.setItem("adminSettings", resultAdminSettings.object)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchGroups = async () => {
        try {
            const groups = await handleGetAllGroups(JSON.parse(window.sessionStorage.getItem("user_data")));
            if(groups.errorcode === 0){dispatch(setAllGroups(groups.object))}
        } catch (error) {
            console.log(error)
        }
    }

    const fetchUserRights = async () => {
        try {
            let f = await handleGetUserRights(JSON.parse(window.sessionStorage.getItem("user_data")).token, JSON.parse(window.sessionStorage.getItem("user_data")).id)
            if(f.errorcode === 0){
                if(typeof(f.object) === "object"){
                    dispatch(setUserRights(f.object))
                    try {
                        if(typeof(f.object.infofiche) === "boolean"){
                            //setview_infofiche(f.object.infofiche)
                            setview_infofiche(f.object.infofiche)
                        }
                    
                        if(f.object.doctypesrights.find(i=>i.doctype==='VFAC').view){ setview_invoices(true)} else { setview_invoices(false) }
                        if(f.object.doctypesrights.find(i=>i.doctype==='WEEGTICK').view){ setview_weighingticket(true)} else { setview_weighingticket(false) }
                    } catch (error) {
                        
                    }
                }
            }
            else {
                console.error('Failed to get user rights');
                console.log(f)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const [fetchProgress, setFetchProgress] = useState(0);

    const [totalSteps, settotalSteps] = useState(14);

    useEffect(()=>{
        if(userdata) {
            settotalSteps(userdata?.role?.toString() === '1' ? 14 : 7)
        }
    }, [userdata])

    const updateProgress = () => {
        setFetchProgress(prev => prev + 1);
    };

    const getDataFetch = async () => {
        try {
            const baseFetches = [
                fetchUserRights,
                fetchDoctypes,
                fetchFiletypes,
                fetchReadFiles,
                fetchUserSettings,
                fetchDossierTypes,
                fetchRelation,
                () => handleGetDossiers(JSON.parse(window.sessionStorage.getItem("user_data")))
            ];
    
            for (const fetchFunc of baseFetches) {
                await fetchFunc();
                updateProgress();
            }
    
            const userData = JSON.parse(window.sessionStorage.getItem("user_data"));
            if (userData.role.toString() === "1") {
                const adminFetches = [
                    fetchNFUDocs,
                    fetchBDocs,
                    fetchRelations,
                    fetchRoles,
                    fetchAdminSettings,
                    fetchGroups
                ];
    
                for (const fetchFunc of adminFetches) {
                    await fetchFunc();
                    updateProgress();
                }
            }
    
            setshowLoader(false);
            setshowDashboard(true);
    
        } catch (error) {
            console.log(error);
            setTimeout(handleLogOut, 2000);
        }
    };

    // const getDataFetch = async () => {
    //     try {
    //         await Promise.all([
    //             fetchUserRights(),
    //             fetchDoctypes(),
    //             fetchFiletypes(),
    //             fetchReadFiles(),
    //             fetchUserSettings(),
    //             fetchDossierTypes(),
    //             fetchRelation(),
    //             handleGetDossiers(JSON.parse(window.sessionStorage.getItem("user_data")))
    //         ])

    //         if(JSON.parse(window.sessionStorage.getItem("user_data")).role.toString() === "1"){
    //             await Promise.all([
    //                 fetchNFUDocs(),
    //                 fetchBDocs(),
    //                 fetchRelations(),
    //                 fetchRoles(),
    //                 fetchAdminSettings(),
    //                 fetchGroups()
    //             ])
    //         }

    //         setshowLoader(false)
    //         setshowDashboard(true)

    //     } catch (error) {
    //         console.log(error);
    //         setTimeout(handleLogOut, 2000)
    //     }
    // }

    const handleLogOut = () =>{
        setshowLoader(false);
        setshowDashboard(false);
        window.localStorage.clear();
        window.sessionStorage.clear();
        navigate('/')
    }

	return (
	    <>	
        <DocumentViewer />

        {showLoader ?
        <LoadingPage progress={`${Math.round((fetchProgress / totalSteps) * 100)}`}/>
        :
        <>
        {(showDashboard) && 
        <>
        <div style={{display:"flex"}}>	
			{/* {console.warn("This admin panel does not work yet, it is just a prototype. It needs a place to save the data on.")} */}
			<Navigation navigationData={navigationData} userRole={"admin"} selectedPage={(page)=>setselectedPage(page)} loggedOut={(v)=>{handleLogOut(v)}} language={ReactSession.get("language")} changeLanguage={(value)=>{handleChangeLanguage(value)}}/>
	    	<div className={styles.main}>
				<div className={styles.header}>
					<div style={{marginRight:"2rem"}} className={styles.header_profile}>
                        
                        <Dropdownlist value={lang_updater} 
                        data={[
                            (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_dutch && content_state[ReactSession.get("language")].General.language_dutch) : "Dutch"), 
                            (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_french && content_state[ReactSession.get("language")].General.language_french) : "French"), 
                            (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_english && content_state[ReactSession.get("language")].General.language_english) : "English")
                        ]} 
                        defaultValue type="language" width="small" onChange={(v)=>{handleChangeLanguage(v)}}/>
                    </div>

                        <div className={styles.profile_info}><div className={styles.profile_picture}><p>{JSON.parse(window.sessionStorage.getItem("user_data")).firstname.charAt(0)}</p></div></div>
                    
				</div>
                <div className={styles.content}>
                    <Routes>
                        <Route path={"*"} element={<CustomerDashboardComp/>}/>

                        <Route path={"Dossiers"} element={<Files/>}/>
                        <Route path={"Files"} element={<Files/>}/>
            
                        <Route path={"Dossiers/:file"} element={<File/>}/>
                        <Route path={"Files/:file"} element={<File/>}/>

                        <Route path={"Documenten"} element={<Documents/>}/>
                        <Route path={"Documents"} element={<Documents/>}/>

                        <Route path={"Facturen"} element={<Invoices />}/>
                        <Route path={"Factures"} element={<Invoices />}/>
                        <Route path={"Invoices"} element={<Invoices />}/>

                        <Route path={"Weegticket"} element={<WeighingTicket />}/>
                        <Route path={"Ticket-de-pesée"} element={<WeighingTicket />}/>
                        <Route path={"Weighing-ticket"} element={<WeighingTicket />}/>

                        <Route path={"Info-Fiche"} element={<InfoFiches />} />

                        <Route path={"Gebruikersbeheer"} element={<UserManagement/>}/>
                        <Route path={"User-Management"} element={<UserManagement/>}/>
                        <Route path={"Gestion-des-utilisateurs"} element={<UserManagement/>}/>
                    </Routes>
                    
                </div>			
            </div>
	    </div>
        </>
        }   
        </>
        }  
	    </>  
  	);
}
 